import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import StyledButtonMenuP from './StyledButtonMenuP';
import SpanPadLeft from '../Utils/spanpadleft';

const BotonMenuN = ({children, Titulo, direccion}) => {
  return (
    <StyledButtonMenuP >
      <NavLink style={{color:"black", textDecoration:"none"}} to={direccion}>
        {children}
        <SpanPadLeft Title={Titulo}/>
      </NavLink>
    </StyledButtonMenuP>
  );
};

BotonMenuN.propTypes = {
  children: PropTypes.node,
  Titulo: PropTypes.string,
  direccion: PropTypes.string
};

export default BotonMenuN;
